<template>
  <vanConfigProvider>
    <router-view v-slot="{ Component, route }">
      <keep-alive :include="cachedComponents">
        <template v-if="true">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
          <!-- <ChatEnter /> -->
          <VisionSelect :showClose="false" @close="closeSystemErrorModal" :showFlag="showFlagRef">
            <template #content>
              <div class="system-error">
                <img
                  class="system-error-background"
                  src="https://img3.airdoc.com/staticResources/data/static/vt_app_train_system_error.png"
                  alt=""
                />
                <div class="system-error-title">{{
                  systemErrorText || '系统出现未知异常，请刷新重试'
                }}</div>

                <div @click="reloadPage" class="system-error-btn">点击刷新</div>
              </div>
            </template>
          </VisionSelect>
        </template>
      </keep-alive>
    </router-view>
  </vanConfigProvider>
</template>

<script setup lang="ts">
  import { computed, onMounted, ref, provide } from 'vue';
  import { useDeviceStore } from '@/store/modules/device';
  import { useUserStore } from '@/store/modules/user';

  import { isIOS } from '@/utils/index';
  import { useRoute } from 'vue-router';
  import VisionSelect from '@/components/visionSelect/index.vue';
  import ChatEnter from '@/components/chatEnter/index.vue';

  const deviceStore = useDeviceStore();
  const userStore = useUserStore();

  const route = useRoute();
  const showFlagRef = computed(() => userStore.showSystemErrorFlag);
  const systemErrorText = computed(() => userStore.systemErrorText);
  provide('showFlag', showFlagRef);

  onMounted(() => {
    let platform = '';
    if (isIOS()) {
      platform = 'ios';
    } else {
      platform = 'android';
    }
    deviceStore.changePlatform(platform);
  });
  const closeSystemErrorModal = () => {};
  const reloadPage = () => {
    userStore.setShowSystemErrorFlag(false);
    window.location.reload();
  };

  // 根据路由元信息 `meta.keepAlive` 来决定哪些组件需要被缓存
  const cachedComponents = computed(() => {
    const components = route.matched.filter((r) => r.meta.keepAlive).map((r) => r.name as string);
    return components;
  });
</script>

<style lang="less">
  #examine-canvas {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 0;
  }
  #loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin: 0 auto;
    display: none;
    z-index: 100;
  }
  #page {
    height: 100%;
    overflow: hidden;
  }
  .system-error {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &-title {
      font-weight: 500;
      font-size: 50px;
      color: #333333;
      margin-bottom: 70px;
    }
    &-background {
      width: 680px;
      object-fit: cover;
      margin-bottom: 74px;
    }
    &-btn {
      width: 455px;
      height: 125px;
      background: #eb4e89;
      border-radius: 63px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 46px;
      margin-bottom: 90px;
    }
  }
</style>
